module.exports = __webpack_public_path__ + "42d3d2d307f81180e0fc03522edf4e7b.fbx";